import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useSelectedAnnotationLabel = () => {
  const {
    selectedAnnotationLabelAtom
  } = useSidePanel();
  const selectedAnnotationLabel = useAtomValue(selectedAnnotationLabelAtom);
  return selectedAnnotationLabel;
};